export enum PopupWhereEnum {
  EducallHomePage = 1,
  StudentDashboard = 2,
}
